import { Card, Typography } from '@mui/material'
import { SideMenu } from 'components/purchase/SideMenu'
import { PurchaseLayout } from 'hoc/PurchaseLayout'
import { useState } from 'react'
import { FaqAccordion } from './faq-accordion'
import { useTranslation } from 'react-i18next'

const breadCrumbs = [
  {
    id: 'home',
    title: 'Ana səhifə',
    path: '/',
  },
  {
    id: 'faq',
    title: 'Tez-tez verilən suallar',
  },
]

export const Faq: React.FC = () => {
  const [breadCrumbItems, setBreadCrumbItems] = useState(breadCrumbs)
  const { t } = useTranslation()

  const renderContent = () => {
    return (
      <>
        <Card>
          <Typography variant="h5">{t('faq')}</Typography>
          <FaqAccordion />
        </Card>
      </>
    )
  }

  return (
    <PurchaseLayout breadCrumbItems={breadCrumbItems} content={renderContent()} />
  )
}
